/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingInsole } from '../../models/thermoforming-insole';
import { UpdateThermoformingInsoleDto } from '../../models/update-thermoforming-insole-dto';

export interface UpdateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params {
  id: number;
      body: UpdateThermoformingInsoleDto
}

export function updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingInsole>;
    })
  );
}

updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole.PATH = '/api/mgmt/thermoforming-insole/{id}';
